import React, {useState, useEffect} from 'react';
import axios from "axios";
import {apiPath, serverToken} from "../../utils/api";
import {CgSpinner} from "react-icons/cg";

function Dashboard() {

    const [isLoading, setIsLoading] = useState(true);
    const [statistics, setStatistics] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);


    useEffect(() => {

        setIsLoading(true);

        const headers = {
            'Authorization': serverToken,
        };

        axios.get(apiPath + '/admin-dashboard', {headers})
            .then(data => {
                setIsLoading(false);
                setStatistics(data.data);
            })

            .catch(error => {
                setIsLoading(false);
                setErrorMsg(error);
            });


    }, []);

    if (!statistics) {
        return (
            <div className="container mx-auto flex justify-center items-center">
                <CgSpinner className="w-8 h-8 animate-spin text-gray-400"/>
            </div>
        );
    }

    return (
        <>
            {/* Card is full width. Use in 12 col grid for best view. */}
            {/* Card code block start */}
            <div className="w-full grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                <div className="bg-gray-50 rounded-[15px] border px-8 py-6 flex items-center">

                    <div className="rounded-md">
                    </div>

                    <div className="">
                        <h3 className="mb-1 leading-5 text-gray-800 font-bold text-2xl">
                            {   !isLoading ?
                            <span>{statistics.users}</span>
                                :
                                <span>Cargando...</span>
                            }
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 text-sm tracking-normal font-normal leading-5">Clientes
                            registrados</p>
                    </div>

                </div>

                <div className="bg-gray-50 rounded-[15px] border px-8 py-6 flex items-center">

                    <div className="rounded-md">
                    </div>

                    <div>
                        <h3 className="mb-1 leading-5 text-gray-800 font-bold text-2xl">
                            {   !isLoading ?
                                <span>{statistics.completed_trips}</span>
                                :
                                <span>Cargando...</span>
                            }
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 text-sm tracking-normal font-normal leading-5">Viajes
                            completados</p>
                    </div>

                </div>

                <div className="bg-gray-50 rounded-[15px] border px-8 py-6 flex items-center">

                    <div className="rounded-md">
                    </div>

                    <div className="">
                        <h3 className="mb-1 leading-5 text-gray-800 font-bold text-2xl">
                            {   !isLoading ?
                                <span>{statistics.cancelled_trips}</span>
                                :
                                <span>Cargando...</span>
                            }
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 text-sm tracking-normal font-normal leading-5">Viajes
                            cancelados</p>
                    </div>

                </div>

                <div className="bg-gray-50 rounded-[15px] border px-8 py-6 flex items-center">

                    <div className="rounded-md">
                    </div>

                    <div className="">
                        <h3 className="mb-1 leading-5 text-gray-800 font-bold text-2xl">
                            {   !isLoading ?
                                <span>{statistics.today_balance}</span>
                                :
                                <span>Cargando...</span>
                            }
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 text-sm tracking-normal font-normal leading-5">Ganancias del día</p>
                    </div>

                </div>
            </div>
            {/* Card code block end */}
        </>
    );
}

export default Dashboard;